<template>
  <v-app>
    <!-- Main content area -->
    <v-main class="main-content">
      <router-view />
    </v-main>

    <!-- Bottom Navigation (shown unless route.meta.hideNav is true) -->
    <v-bottom-navigation
        v-if="!$route.meta.hideNav"
        app
        grow
        height="64"
        :color="$vuetify.theme.dark ? 'grey darken-4' : 'white'"
        class="custom-nav-bar"
    >
      <v-btn
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          exact
          replace
          ripple
          icon
          class="flex-column nav-btn"
          :class="{ 'active-btn': $route.path === item.to }"
          :aria-label="item.label"
      >
        <v-icon class="transition-fast-in-fast-out" :color="$route.path === item.to ? 'primary' : 'grey'" size="20">
          {{ item.icon }}
        </v-icon>

        <span
            class="text-sm mt-1 font-weight-medium nav-label"
            :style="{ color: $route.path === item.to ? 'var(--v-primary-base)' : 'var(--v-text-secondary)' }"
            :class="{ 'text-primary': $route.path === item.to }"
        >
          {{ item.label }}
        </span>

        <!-- Active underline indicator -->
        <div class="active-indicator" v-if="$route.path === item.to"></div>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        { label: "Mood", icon: "fas fa-smile", to: "/mood" },
        { label: "Cognitive", icon: "fas fa-brain", to: "/cognitive" },
        { label: "Journal", icon: "fas fa-pen", to: "/emotion" },
        { label: "Alerts", icon: "fas fa-chart-line", to: "/alerts" },
      ],
    };
  },
};
</script>

<style scoped>
/* Main content should take full height except nav */
.main-content {
  padding-bottom: 64px; /* Ensure content isn't hidden behind bottom nav */
}

/* Navigation Bar Enhancements */
.custom-nav-bar {
  border-top: none;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
  height: 64px !important;
  z-index: 10;
}

/* Button & Label Styling */
.nav-btn {
  min-width: 64px;
  padding: 8px 0;
  position: relative;
  border-radius: 12px;
}

/* Label font */
.nav-label {
  font-size: 0.75rem;
}

/* Active Button Background */
.active-btn {
  background-color: rgba(25, 118, 210, 0.1);
}

/* Active Tab Indicator */
.active-indicator {
  height: 4px;
  width: 24px;
  border-radius: 2px;
  background-color: #1976d2;
  margin-top: 4px;
}

/* Icon transition */
.v-icon {
  transition: transform 0.2s ease, color 0.2s ease;
}
</style>
